"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ibanFormat = void 0;
const EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
const NON_ALPHANUM = /[^a-zA-Z0-9]/g;
/**
 * Formatuje ciąg znaków na IBAN
 *
 * @export
 * @param {string} value poprawna wartość IBAN
 * @param {string} [separator=' ']
 * @return
 */
function ibanFormat(value, separator = ' ') {
    if (!value) {
        return;
    }
    const prepareValue = value.replace(NON_ALPHANUM, '').toUpperCase();
    const prepLength = prepareValue.length % 4;
    const prepend = prepareValue.substring(0, prepLength);
    const rest = prepareValue.substring(prepLength);
    return prepend + separator + rest.replace(EVERY_FOUR_CHARS, '$1' + separator);
}
exports.ibanFormat = ibanFormat;
//# sourceMappingURL=ibanFormat.js.map